import styled, { DefaultTheme } from 'styled-components';

type Props = {
  theme: DefaultTheme;
  $isDisabled?: boolean;
  $isError?: boolean;
  $isFocus?: boolean;
  $isTight?: boolean;
  $minWidth?: number;
};

// Handle border color
const handleBorderColor = ({ theme, $isError, $isDisabled }: Props) => {
  if ($isDisabled) {
    return theme.colors.grey2;
  }

  if ($isError) {
    return theme.colors.error;
  }

  return theme.colors.grey3;
};

export const Container = styled.div`
  position: relative;
`;

export const InputContainer = styled.div<Props>`
  display: flex;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 16px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? '0.7' : '1')};
  background-clip: padding-box;
  padding-bottom: ${({ $isTight }) => ($isTight ? '15px' : '16px')};
  border: 1px solid ${handleBorderColor};
  height: ${({ $isTight }) => ($isTight ? '50px' : '56px')};
  box-sizing: border-box;
`;

export const Input = styled.input<Props>`
  width: 100%;
  outline: none;
  border: none;
  padding: ${({ $isTight }) => ($isTight ? '22px 14px 6px' : '24px 14px 8px')};
  min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '180px')};
  font-size: 16px;
  line-height: ${({ $isTight }) => ($isTight ? '22px' : '24px')};
  transition: all 0.3s ease-out;
  -webkit-appearance: none;
  border-radius: 16px;
  caret-color: ${({ theme }) => theme.colors.primary};

  &::placeholder {
    color: transparent;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label,
  &:-webkit-autofill + label {
    font-size: 12px;
    margin-top: ${({ $isTight }) => ($isTight ? '6px' : '8px')};
    line-height: ${({ $isTight }) => ($isTight ? '14px' : '16px')};
  }

  /* Chrome, Safari, Edge */
  &::-webkit-calendar-picker-indicator {
    display: none;
  }

  /* Firefox */
  -moz-appearance: textfield;   /* hide the native icon */
  appearance: textfield;        /* modern */
  background-image: none !important; 
`;

export const InputLabel = styled.label<Props>`
  position: absolute;
  margin-top: ${({ $isTight }) => ($isTight ? '15px' : '16px')};
  line-height: ${({ $isTight }) => ($isTight ? '22px' : '24px')};
  font-size: 16px;
  color: ${({ theme, $isError, $isFocus }) => {
    if ($isError && $isFocus) {
      return theme.colors.error;
    }

    return theme.colors.onSurface;
  }};
  pointer-events: none;
  transition: all 0.3s ease-out;
  top: 0;
  left: 16px;
`;
export const InputLabelNoDescription = styled.label<Props>`
  position: absolute;
  margin-top: ${({ $isTight }) => ($isTight ? '15px' : '16px')};
  line-height: ${({ $isTight }) => ($isTight ? '22px' : '24px')};
  font-size: 16px;
  color: ${({ theme, $isError, $isFocus }) => {
    if ($isError && $isFocus) {
      return theme.colors.error;
    }

    return theme.colors.onSurface;
  }};
  pointer-events: none;
  transition: all 0.3s ease-out;
  top: 0;
  left: 16px;
`;

export const InputButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  padding: 0 16px;
  border: none;
  cursor: pointer;

  img {
    width: 24px;
    height: 24px;
  }
`;

export const ErrorIcon = styled.img`
  margin-right: 16px;
  width: 24px;
`;

export const ErrorMessage = styled.p<Props>`
  display: ${({ $isTight }) => ($isTight ? 'none' : 'block')};
  color: ${({ theme }) => theme.colors.error};
  font-weight: bold;
  height: 16px;
  font-size: 12px;
  padding: 4px 16px;
  margin: 0 0 8px;
`;
